import { IGetDataset } from '../Models/IGetDataset';
import { IGetProjectPath, IGetCustomProject } from '../Models/IGetProject';
import ActionType from './ActionType';

export const getProjectContent = (project: IGetCustomProject | IGetProjectPath) => ({
  type: ActionType.GET_PROJECTCONTENT,
  data: project,
});

export const getProjectAndParent = (projectId: string) => ({
  type: ActionType.GET_PROJECTANDPARENT,
  data: projectId,
});

export const setLoadingProjectContent = (loading = true) => ({
  type: ActionType.LOADING_PROJECTCONTENT,
  data: loading,
});

export const setLoadingProjectAndParent = (loading = true) => ({
  type: ActionType.LOADING_PROJECTANDPARENT,
  data: loading,
});

export const setProjectAndParent = (
  project: IGetCustomProject | null,
  projectParent: IGetCustomProject | null
) => ({
  type: ActionType.SET_PROJECTANDPARENT,
  data: { project: project, projectParent: projectParent },
});

export const setProjectContent = (
  projectContent: (IGetDataset | IGetCustomProject)[],
  project: IGetCustomProject | null,
  parent: IGetCustomProject | null,
  path: IGetProjectPath[]
) => ({
  type: ActionType.SET_PROJECTCONTENT,
  data: { projectContent: projectContent, project: project, parent: parent, path: path },
});

export const setProjectContentDialogOpen = (open: boolean, selectable: boolean) => ({
  type: ActionType.OPEN_PROJECTCONTENT_DIALOG,
  data: { open: open, selectable: selectable },
});

export const setProjectContentPage = (page: number) => ({
  type: ActionType.SET_PROJECTCONTENT_PAGE,
  data: page,
});

export const setProjectContentRowsPerPage = (rowsPerPage: number) => ({
  type: ActionType.SET_PROJECTCONTENT_ROWSPERPAGE,
  data: rowsPerPage,
});

export const setProjectContentOrder = (order: 'asc' | 'desc') => ({
  type: ActionType.SET_PROJECTCONTENT_ORDER,
  data: order,
});

export const setProjectContentOrderBy = (orderBy: string | ((item: any) => string | number)) => ({
  type: ActionType.SET_PROJECTCONTENT_ORDERBY,
  data: orderBy,
});
